import _ from 'lodash'
import { isSSR } from '@wix/thunderbolt-commons'
import { named, optional, withDependencies } from '@wix/thunderbolt-ioc'
import {
	BrowserWindow,
	BrowserWindowSymbol,
	CurrentRouteInfoSymbol,
	Experiments,
	ExperimentsSymbol,
	PlatformEnvData,
	PlatformEnvDataProvider,
	PlatformSiteConfig,
	SiteFeatureConfigSymbol,
	ViewerModel,
	ViewerModelSym,
	WixBiSession,
	WixBiSessionSymbol,
} from '@wix/thunderbolt-symbols'
import { ISessionManager, SessionManagerSymbol } from 'feature-session-manager'
import { ICurrentRouteInfo, UrlHistoryManagerSymbol, IUrlHistoryManager } from 'feature-router'
import { IPopupsLinkUtilsAPI, PopupsLinkUtilsAPISymbol } from 'feature-popups'
import { name } from '../symbols'

export const biEnvDataProvider = withDependencies(
	[
		named(SiteFeatureConfigSymbol, name),
		BrowserWindowSymbol,
		WixBiSessionSymbol,
		SessionManagerSymbol,
		ViewerModelSym,
		UrlHistoryManagerSymbol,
		ExperimentsSymbol,
		CurrentRouteInfoSymbol,
		optional(PopupsLinkUtilsAPISymbol),
	],
	(
		platformSiteConfig: PlatformSiteConfig,
		window: BrowserWindow,
		wixBiSession: WixBiSession,
		sessionManager: ISessionManager,
		viewerModel: ViewerModel,
		urlHistoryManager: IUrlHistoryManager,
		experiments: Experiments,
		currentRoutingInfo: ICurrentRouteInfo,
		popupsLinkUtilsAPI: IPopupsLinkUtilsAPI
	): PlatformEnvDataProvider => {
		let pageNumber = 0
		const { mode, rollout, fleetConfig } = viewerModel
		const bi = {
			..._.omit(wixBiSession, 'checkVisibility'),
			visitorId: sessionManager.getVisitorId(),
			siteMemberId: sessionManager.getSiteMemberId(),
			viewerVersion: process.env.browser ? window!.thunderboltVersion : (process.env.APP_VERSION as string),
			rolloutData: rollout,
			fleetConfig,
		}

		return {
			get platformEnvData(): { bi: PlatformEnvData['bi'] } {
				const pageId = currentRoutingInfo.getCurrentRouteInfo()?.pageId

				const { href, searchParams } = urlHistoryManager.getParsedUrl()

				const suppressBi = searchParams.has('suppressbi') && searchParams.get('suppressbi') !== 'false'
				if (!pageId) {
					// TODO: Maybe we can have a single return and set the defaults on it?
					// platform init
					return {
						bi: {
							...bi,
							// @ts-ignore
							pageData: {
								pageNumber: 1,
							},
							// @ts-ignore
							rolloutData: {},
							// @ts-ignore
							fleetConfig: {},
							muteFedops: mode.qa || suppressBi,
						},
					}
				}

				const currentLightboxId = popupsLinkUtilsAPI?.getCurrentOrPendingPopupId()
				const isLightbox = !!currentLightboxId

				if (!isLightbox) {
					pageNumber++
				}

				const biPageData = {
					pageNumber,
					pageId: currentLightboxId || pageId,
					pageUrl: href,
					isLightbox,
				}

				const muteBi = (isSSR(window) || mode.qa || suppressBi) && !experiments.sv_reportTrace
				const muteFedops = mode.qa || suppressBi || isLightbox

				return {
					bi: {
						...platformSiteConfig.bootstrapData.bi,
						...bi,
						pageData: biPageData,
						muteBi,
						muteFedops,
					},
				}
			},
		}
	}
)
